var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCategorySocialMedia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 13C5 10.1997 5 8.79961 5.54497 7.73005C6.02433 6.78924 6.78924 6.02433 7.73005 5.54497C8.79961 5 10.1997 5 13 5H27C29.8003 5 31.2004 5 32.27 5.54497C33.2108 6.02433 33.9757 6.78924 34.455 7.73005C35 8.79961 35 10.1997 35 13V22.5C35 24.8297 35 25.9946 34.6194 26.9134C34.1119 28.1386 33.1386 29.1119 31.9134 29.6194C30.9946 30 29.8297 30 27.5 30C26.6857 30 26.2786 30 25.9008 30.0892C25.3972 30.2081 24.9281 30.4426 24.5308 30.7742C24.2329 31.0228 23.9886 31.3486 23.5 32L21.0667 35.2444C20.7048 35.7269 20.5239 35.9682 20.3021 36.0544C20.1078 36.13 19.8922 36.13 19.6979 36.0544C19.4761 35.9682 19.2952 35.7269 18.9333 35.2444L16.5 32C16.0114 31.3486 15.7671 31.0228 15.4692 30.7742C15.0719 30.4426 14.6028 30.2081 14.0992 30.0892C13.7214 30 13.3143 30 12.5 30C10.1703 30 9.00544 30 8.08658 29.6194C6.86144 29.1119 5.88807 28.1386 5.3806 26.9134C5 25.9946 5 24.8297 5 22.5V13Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.9954 13.8843C18.6625 12.3693 16.4398 11.9618 14.7698 13.3491C13.0998 14.7364 12.8646 17.0558 14.1761 18.6966C14.956 19.6722 16.8661 21.4218 18.2865 22.6799C18.8729 23.1992 19.166 23.4589 19.5189 23.5642C19.8208 23.6543 20.17 23.6543 20.4719 23.5642C20.8248 23.4589 21.118 23.1992 21.7043 22.6799C23.1247 21.4218 25.0349 19.6722 25.8147 18.6966C27.1262 17.0558 26.9198 14.7218 25.2211 13.3491C23.5223 11.9764 21.3283 12.3693 19.9954 13.8843Z",
    stroke: "#6374A6",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategorySocialMedia);
export default __webpack_public_path__ + "react/media/category-social_media.39c7b116d50a3e851f0ce23c6fe2a620.svg";
export { ForwardRef as ReactComponent };